import React from 'react';
import ProfileShell from '../../components/forms/ProfileShell';
import { SectionHeader, Field, Input, Select, Toggle, TextArea } from '../../components/forms/FormPrimitives';

const ROOF_TYPES = ['Composition Shingle', 'Tile', 'Metal', 'Wood Shake', 'Slate', 'Flat', 'Other'];
const FOUNDATIONS = ['Slab', 'Pier and Beam', 'Basement', 'Crawl Space', 'Other'];
const STORIES = ['1', '2', '3', '4+'];
const PROPERTY_USE = ['Primary home', 'Rental property', 'Secondary home', 'Vacation home'];

const HomeProfile = () => {
  const sections = [
    {
      title: 'Property Information',
      render: (data, update) => (
        <div>
          <SectionHeader index={1} title="Property Information" subtitle="Tell us about the home we're protecting." />
          <Field label="Property Address" testid="home-address">
            <Input value={data.property_address} onChange={(v) => update({ property_address: v })} placeholder="123 Main St, Dallas, TX" />
          </Field>
          <div className="grid sm:grid-cols-2 gap-4 mt-4">
            <Field label="Year Built" testid="home-year-built">
              <Input value={data.year_built} onChange={(v) => update({ year_built: v })} placeholder="1998" />
            </Field>
            <Field label="Square Footage" testid="home-sqft">
              <Input value={data.square_footage} onChange={(v) => update({ square_footage: v })} placeholder="2100" />
            </Field>
            <Field label="Roof Age (years)" testid="home-roof-age">
              <Input value={data.roof_age} onChange={(v) => update({ roof_age: v })} placeholder="5" />
            </Field>
            <Field label="Roof Type" testid="home-roof-type">
              <Select value={data.roof_type} onChange={(v) => update({ roof_type: v })} options={ROOF_TYPES} />
            </Field>
            <Field label="Foundation Type" testid="home-foundation">
              <Select value={data.foundation_type} onChange={(v) => update({ foundation_type: v })} options={FOUNDATIONS} />
            </Field>
            <Field label="Number of Stories" testid="home-stories">
              <Select value={data.stories} onChange={(v) => update({ stories: v })} options={STORIES} />
            </Field>
          </div>
        </div>
      ),
    },
    {
      title: 'Current Insurance',
      render: (data, update) => (
        <div>
          <SectionHeader index={2} title="Current Insurance" subtitle="If you have a current policy, share what you know." />
          <div className="grid sm:grid-cols-2 gap-4">
            <Field label="Current Carrier" testid="home-carrier">
              <Input value={data.current_carrier} onChange={(v) => update({ current_carrier: v })} placeholder="e.g. Allstate" />
            </Field>
            <Field label="Current Annual Premium" testid="home-premium">
              <Input value={data.current_premium} onChange={(v) => update({ current_premium: v })} placeholder="$1,800" />
            </Field>
            <Field label="Current Deductible" testid="home-deductible">
              <Input value={data.current_deductible} onChange={(v) => update({ current_deductible: v })} placeholder="$2,500" />
            </Field>
            <Field label="Claims in past 5 years?" testid="home-claims">
              <Select value={data.claims_5y} onChange={(v) => update({ claims_5y: v })} options={['None', '1', '2', '3+']} />
            </Field>
            <Field label="Mortgage Company" testid="home-mortgage">
              <Input value={data.mortgage_company} onChange={(v) => update({ mortgage_company: v })} placeholder="e.g. Chase" />
            </Field>
          </div>
        </div>
      ),
    },
    {
      title: 'Property Details & Discounts',
      render: (data, update) => (
        <div>
          <SectionHeader index={3} title="Property Details & Discounts" subtitle="These details may help us find discounts." />
          <div className="space-y-3 mb-4">
            <Toggle value={data.bundle_auto} onChange={(v) => update({ bundle_auto: v })} label="Interested in bundling auto insurance" testid="home-bundle" />
            <Toggle value={data.alarm_system} onChange={(v) => update({ alarm_system: v })} label="Alarm system installed" testid="home-alarm" />
            <Toggle value={data.pool} onChange={(v) => update({ pool: v })} label="Pool on property" testid="home-pool" />
            <Toggle value={data.trampoline} onChange={(v) => update({ trampoline: v })} label="Trampoline on property" testid="home-trampoline" />
            <Toggle value={data.dogs} onChange={(v) => update({ dogs: v })} label="Dogs on property" testid="home-dogs" />
          </div>
          {data.dogs && (
            <Field label="Breed(s) of dog(s)" testid="home-dog-breed">
              <Input value={data.dog_breed} onChange={(v) => update({ dog_breed: v })} placeholder="e.g. Labrador" />
            </Field>
          )}
          <Field label="Property Use" testid="home-use">
            <Select value={data.property_use} onChange={(v) => update({ property_use: v })} options={PROPERTY_USE} />
          </Field>
          <Field label="Anything else we should know?" testid="home-notes">
            <TextArea value={data.profile_notes} onChange={(v) => update({ profile_notes: v })} placeholder="Optional notes about your property" />
          </Field>
        </div>
      ),
    },
  ];

  return (
    <ProfileShell
      coverageType="home"
      sections={sections}
      personalTouchMessage="Your home is one of your biggest investments. Complete what you can — we'll help review options that fit your property and budget."
    />
  );
};

export default HomeProfile;
